import { Component, signal, effect, inject, output } from '@angular/core';
import { BannerNotificationService } from '../../services/banner-notification.service';
import { I18nService } from '../../services/i18n.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { I18N_KEYS } from '../../enums/i18.enum';

@Component({
  selector: 'app-banner-notification',
  imports: [NzIconModule],
  templateUrl: './banner-notification.component.html',
  styleUrls: ['./banner-notification.component.scss'],
})
export class BannerNotificationComponent {
  private bannerNotificationService = inject(BannerNotificationService);
  public i18n = inject(I18nService);

  showBannerNotification = signal<boolean>(false);
  bannerNotificationType = signal<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  bannerNotificationTitle = signal<string | null>(null);
  bannerNotificationMessage = signal<string | null>(null);

  notificationClosed = output<void>();

  constructor() {
    effect(() => {
      this.bannerNotificationService.getBannerNotifications().then((res) => {
        const notificationTypes = ['maintenance', 'outage', 'custom'];
        const notification: any = notificationTypes
          .map((type) => res.find((r: any) => r.type === type))
          .find((n) => n);

        if (notification) {
          this.showBannerNotification.set(true);
          this.bannerNotificationType.set(notification.type);

          switch (notification.type) {
            case 'maintenance':
              this.bannerNotificationTitle.set(this.i18n.langString(I18N_KEYS.SYSTEM_MAINTENANCE));
              this.bannerNotificationMessage.set(
                this.i18n.langString(I18N_KEYS.MAINTENANCE_MESSAGE)
              );
              break;
            case 'outage':
              this.bannerNotificationTitle.set(this.i18n.langString(I18N_KEYS.SYSTEM_OUTAGE));
              this.bannerNotificationMessage.set(this.i18n.langString(I18N_KEYS.OUTAGE_MESSAGE));
              break;
            case 'custom':
              this.bannerNotificationTitle.set(this.i18n.parse(notification.title));
              this.bannerNotificationMessage.set(this.i18n.parse(notification.message));
              break;
          }
        }
      });
    });
  }

  closeBannerNotification() {
    this.bannerNotificationService.dismissBannerNotification(this.bannerNotificationType()).then(
      () => {
        this.showBannerNotification.set(false);
        this.bannerNotificationType.set(GLOBAL_CONSTANT.EMPTY_STRING);
        this.bannerNotificationTitle.set(null);
        this.bannerNotificationMessage.set(null);
        this.notificationClosed.emit();
      },
      (error) => console.error(error)
    );
  }
}
